import React, { Component } from "react";
import { Row, Col, Tag, Alert, DatePicker, Spin, Table, Empty, Button, Tooltip, message } from "antd";
import { PlayCircleOutlined, FileTextOutlined, LeftOutlined, RightOutlined, BulbOutlined } from "@ant-design/icons";
import moment from "moment";
import { DynamicCardForm, SegmentedItem, ButtonItem } from "../../../../Components/Items";
import { cmmsPost, estatusPlan, estatusServicio, formatoFecha, formatoFechaHora, fechaDiaPayload, formatoPorcentaje } from "../cmmsComun";
import { Medidor, Tile, FilaTiles } from "../componentes/IndicadoresCMMS";
import DrawerPlanCMMS from "../componentes/DrawerPlanCMMS";
import FiltroIngenieroCMMS, { miFiltroCMMS } from "../componentes/FiltroIngenieroCMMS";
import { cargarListasCMMS } from "../componentes/accionesPlanes";
import "../cmms.css";

const { RangePicker } = DatePicker;

// "Mis servicios": como va un ingeniero. Por default el que fijo el usuario en el filtro o, si
// no fijo ninguno, el ligado a su usuario (Configuracion CMMS > Ingenieros); se puede ver el
// de otro. Muestra lo de hoy y la semana, lo atrasado, lo que le sugirieron, sus servicios
// abiertos y su avance contra lo que tiene asignado en el programa.

const periodoDe = (tipo, ancla) => {
    const a = moment(ancla);
    if (tipo === "mes") return [a.clone().startOf("month"), a.clone().endOf("month")];
    return [a.clone().startOf("isoWeek"), a.clone().endOf("isoWeek")];
};

class MisServicios extends Component {
    state = { cargando: false, empleadoId: null, empleadoPropio: null, tipoPeriodo: "semana", rango: periodoDe("semana", moment()), datos: null, plan: null, motivos: [] };

    async componentDidMount() {
        cargarListasCMMS(this.props).then((c) => this.setState({ motivos: c.motivosNoRealizado || [] }));
        const f = await miFiltroCMMS(this.props);
        const empleadoPropio = f.empleadoId || f.ingenieroId || null;
        if (empleadoPropio) this.setState({ empleadoId: empleadoPropio, empleadoPropio });
        this.consultar();
    }

    consultar = async () => {
        this.setState({ cargando: true });
        try {
            const res = await cmmsPost(this.props, "misServiciosCMMS", {
                empleadoId: this.state.empleadoId,
                desde: fechaDiaPayload(this.state.rango[0]),
                hasta: fechaDiaPayload(this.state.rango[1]),
            });
            if (res.data.success === 2)
                this.setState((s) => ({
                    datos: res.data,
                    plan: s.plan ? [...(res.data.atrasados || []), ...(res.data.proximos || []), ...(res.data.sugeridos || [])].find((p) => p._id === s.plan._id) || null : null,
                }));
            else message.error(res.data.message || "No se pudo consultar");
        } catch (error) {
            console.log(error);
            message.error("No se pudo consultar");
        } finally {
            this.setState({ cargando: false });
        }
    };

    moverPeriodo = (paso) => {
        const unidad = this.state.tipoPeriodo === "mes" ? "month" : "week";
        this.setState((s) => ({ rango: periodoDe(s.tipoPeriodo, s.rango[0].clone().add(paso, unidad)) }), this.consultar);
    };

    listaPlanes(planes, vacio) {
        if (!planes?.length) return <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={vacio} />;
        return planes.map((p) => (
            <div key={p._id} className="cmms-agenda-item" style={{ cursor: "pointer" }} onClick={() => this.setState({ plan: p })}>
                <div style={{ width: 82, flex: "0 0 82px" }}>
                    <Tag color={estatusPlan(p.estatusVisible).color} style={{ marginRight: 0 }}>
                        {p.fechaPlaneada ? formatoFecha(p.fechaPlaneada) : "Sin fecha"}
                    </Tag>
                </div>
                <div style={{ flex: 1, minWidth: 0 }}>
                    <div className="cmms-agenda-item-titulo">{p.activoTexto}</div>
                    <div className="cmms-agenda-item-sub">
                        {[p.sucursalNombre || p.clienteNombre, p.contratoNombre && `${p.contratoNombre} · ${p.vueltaNombre}`].filter(Boolean).join(" · ")}
                        {p.paraTodos ? (
                            <Tag icon={<BulbOutlined />} style={{ marginLeft: 6 }}>
                                Para todos
                            </Tag>
                        ) : null}
                    </div>
                </div>
                {p.estatus === 1 && !p.servicioId && !p.contratoCancelado ? (
                    <Tooltip title="Iniciar servicio">
                        <ButtonItem
                            type="default"
                            size="small"
                            cyan
                            icon={<PlayCircleOutlined />}
                            onClick={(e) => {
                                e.stopPropagation();
                                this.props.history.push("/panel/cmmsServicio", { planId: p._id });
                            }}
                        />
                    </Tooltip>
                ) : p.servicioId ? (
                    <Tooltip title={`Abrir ${p.servicioCodigo}`}>
                        <ButtonItem
                            type="default"
                            size="small"
                            icon={<FileTextOutlined />}
                            onClick={(e) => {
                                e.stopPropagation();
                                this.props.history.push("/panel/cmmsServicio", { id: p.servicioId });
                            }}
                        />
                    </Tooltip>
                ) : null}
            </div>
        ));
    }

    render() {
        const d = this.state.datos;
        const r = d?.resumen;
        const [ini, fin] = this.state.rango;
        const abrir = (id) => this.props.history.push("/panel/cmmsServicio", { id });
        return (
            <Spin spinning={this.state.cargando}>
                <div className="cmms-filtros">
                    <FiltroIngenieroCMMS
                        {...this.props}
                        width={320}
                        placeholder={this.state.empleadoPropio ? "Mis servicios" : "Elija un ingeniero"}
                        value={this.state.empleadoId}
                        onChange={(empleadoId) => this.setState({ empleadoId: empleadoId || this.state.empleadoPropio }, this.consultar)}
                    />
                    <SegmentedItem
                        options={[
                            { label: "Semana", value: "semana" },
                            { label: "Mes", value: "mes" },
                            { label: "Rango", value: "rango" },
                        ]}
                        value={this.state.tipoPeriodo}
                        onChange={(tipoPeriodo) =>
                            this.setState((s) => ({ tipoPeriodo, rango: tipoPeriodo === "rango" ? s.rango : periodoDe(tipoPeriodo, moment()) }), () => tipoPeriodo !== "rango" && this.consultar())
                        }
                    />
                    {this.state.tipoPeriodo === "rango" ? (
                        <RangePicker format="DD/MM/YYYY" value={this.state.rango} allowClear={false} onChange={(rango) => rango && this.setState({ rango }, this.consultar)} />
                    ) : (
                        <span style={{ display: "inline-flex", alignItems: "center", gap: 6 }}>
                            <Button size="small" icon={<LeftOutlined />} onClick={() => this.moverPeriodo(-1)} />
                            <b style={{ minWidth: 170, textAlign: "center" }}>
                                {this.state.tipoPeriodo === "mes" ? ini.format("MMMM YYYY") : `${ini.format("D MMM")} – ${fin.format("D MMM YYYY")}`}
                            </b>
                            <Button size="small" icon={<RightOutlined />} onClick={() => this.moverPeriodo(1)} />
                        </span>
                    )}
                </div>

                {d?.sinVinculo ? (
                    <Alert
                        type="info"
                        showIcon
                        message="Su usuario no está ligado a un ingeniero"
                        description="Elija arriba al ingeniero que quiere consultar (si es usted, fíjelo con la chincheta para que siempre arranque con él), o pida que lo liguen en CMMS › Configuración › Ingenieros."
                    />
                ) : !d ? null : (
                    <Row gutter={14}>
                        <Col xs={24}>
                            <div style={{ fontWeight: 600, fontSize: 15, marginBottom: 8 }}>{d.empleadoNombre}</div>
                            <FilaTiles>
                                <Tile titulo="Avance del programa" valor={r.avance === null ? "—" : formatoPorcentaje(r.avance)} detalle={`${r.realizados} de ${r.asignados} asignados en el periodo`}>
                                    {r.asignados ? <Medidor valor={r.avance} texto="" /> : null}
                                </Tile>
                                <Tile titulo="Servicios concluidos" valor={r.concluidos} detalle={r.horas ? `${r.horas} h de servicio` : "En el periodo"} />
                                <Tile titulo="Abiertos" valor={r.abiertos} detalle={`${r.programados} programados · ${r.enProceso} en proceso`} />
                                <Tile titulo="Atrasados" valor={<span style={{ color: r.atrasados ? "#b4581c" : undefined }}>{r.atrasados}</span>} detalle="Su fecha ya pasó" />
                                <Tile titulo="No realizados" valor={r.noRealizados} detalle="En el periodo, con motivo" />
                            </FilaTiles>
                        </Col>
                        <DynamicCardForm title={`Próximos 7 días (${d.proximos.length})`} xs={24} lg={12}>
                            <div className="cmms-agenda-lista">{this.listaPlanes(d.proximos, "Nada calendarizado para los próximos días")}</div>
                        </DynamicCardForm>
                        <DynamicCardForm title={`Atrasados (${d.atrasados.length})`} xs={24} lg={12}>
                            <div className="cmms-agenda-lista">{this.listaPlanes(d.atrasados, "Nada atrasado")}</div>
                        </DynamicCardForm>
                        {d.sugeridos?.length > 0 && (
                            <DynamicCardForm
                                title={`Sugeridos (${d.sugeridos.length})`}
                                xs={24}
                                headerRight={
                                    <ButtonItem type="default" size="small" blanco onClick={() => this.props.history.push("/panel/cmmsAgenda")}>
                                        Ir a la Agenda
                                    </ButtonItem>
                                }
                            >
                                <div className="cmms-ayuda">
                                    Equipos todavía sin fecha: los que se le sugirieron a este ingeniero ({r.sugeridos}) y los que no tienen ingeniero, que son para todos ({r.paraTodos || 0}). Póngales fecha (clic en el
                                    renglón) o inicie el servicio en sitio.
                                </div>
                                <div className="cmms-agenda-lista">{this.listaPlanes(d.sugeridos, "")}</div>
                            </DynamicCardForm>
                        )}
                        <DynamicCardForm title={`Mis servicios abiertos (${d.abiertos.length})`} xs={24} lg={12}>
                            <Table
                                size="small"
                                rowKey="_id"
                                pagination={{ pageSize: 10, size: "small", hideOnSinglePage: true }}
                                dataSource={d.abiertos}
                                onRow={(x) => ({ onDoubleClick: () => abrir(x._id), style: { cursor: "pointer" } })}
                                locale={{ emptyText: "Sin servicios abiertos" }}
                                columns={[
                                    { title: "Folio", dataIndex: "codigo", width: 95, render: (v, x) => (<Button type="link" size="small" style={{ padding: 0 }} onClick={() => abrir(x._id)}>{v}</Button>) },
                                    { title: "Equipo", dataIndex: "activoTexto", render: (v, x) => (<span>{v}<div className="cmms-agenda-item-sub">{x.clienteNombre}</div></span>) },
                                    { title: "Estatus", dataIndex: "estatus", width: 110, render: (v, x) => (<Tag color={estatusServicio(v).color}>{x.deApoyo ? "Apoyo" : estatusServicio(v).label}</Tag>) },
                                ]}
                            />
                        </DynamicCardForm>
                        <DynamicCardForm title="Avance por contrato" xs={24} lg={12}>
                            <Table
                                size="small"
                                rowKey="contrato"
                                pagination={false}
                                dataSource={d.porContrato}
                                locale={{ emptyText: "Sin servicios asignados en el periodo" }}
                                columns={[
                                    { title: "Contrato", dataIndex: "contrato" },
                                    { title: "Asignados", dataIndex: "asignados", width: 85, align: "right" },
                                    { title: "Realizados", dataIndex: "realizados", width: 90, align: "right" },
                                    { title: "Avance", dataIndex: "avance", width: 160, render: (v) => <Medidor valor={v} /> },
                                ]}
                            />
                            {d.porTipo.length > 0 && (
                                <div style={{ marginTop: 10 }}>
                                    <div className="cmms-etiqueta-campo">Concluidos por tipo</div>
                                    {d.porTipo.map((t) => (
                                        <Tag key={t.tipo}>
                                            {t.tipo}: <b>{t.n}</b>
                                        </Tag>
                                    ))}
                                </div>
                            )}
                        </DynamicCardForm>
                        <DynamicCardForm title={`Concluidos en el periodo (${d.concluidos.length})`} xs={24}>
                            <Table
                                size="small"
                                rowKey="_id"
                                pagination={{ pageSize: 10, size: "small", hideOnSinglePage: true }}
                                dataSource={d.concluidos}
                                onRow={(x) => ({ onDoubleClick: () => abrir(x._id), style: { cursor: "pointer" } })}
                                locale={{ emptyText: "Ninguno en el periodo" }}
                                columns={[
                                    { title: "Folio", dataIndex: "codigo", width: 95 },
                                    { title: "Folio externo", dataIndex: "folioExterno", width: 150 },
                                    { title: "Conclusión", dataIndex: "fecha", width: 150, render: (v) => formatoFechaHora(v) },
                                    { title: "Tipo", dataIndex: "tipoServicioNombre", width: 190 },
                                    { title: "Equipo", dataIndex: "activoTexto" },
                                    { title: "Cliente", dataIndex: "clienteNombre", width: 220 },
                                ]}
                            />
                        </DynamicCardForm>
                    </Row>
                )}
                <DrawerPlanCMMS
                    {...this.props}
                    visible={!!this.state.plan}
                    plan={this.state.plan}
                    puedeMover={d?.puedeMover !== false}
                    motivos={this.state.motivos}
                    onClose={() => this.setState({ plan: null })}
                    onCambio={(soloTexto) => this.setState(soloTexto ? {} : { plan: null }, this.consultar)}
                />
            </Spin>
        );
    }
}

export default MisServicios;
